<!--
/*******************************************************************************
*@ 컴포넌트명   : CorporationInfoTab3.vue
*@ 컴포넌트설명 : 고객정보조회/변경 - 수정 [기업] : 대표자주소
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <div class="form">
    <!-- 우편번호 -->
    <div class="form-row">
      <input-text
        ref="rprsNmad"
        id="rprsNmad"
        :value.sync="data.rprsNmad"
        label-i18n="MCOP-01-01-05-06"
        placeholder="MCOP-01-01-05-06"
        :maxlength="10"
        :err-msg-param="{filed:$t('MCOP-01-01-05-06'), max:10}"
        toLowerCase
      />
    </div>
    <!-- 상세 주소 : 인도, 오클랜드 제외 -->
    <div class="form-row">
      <div class="item-tit">
        {{ /*상세 주소*/ $t("MCOP-01-01-05-07") }}
        <required />
      </div>
      <div class="item-desc">
        <div class="form-text-field">
          <div class="input-text-field address">
            <input-text
              ref="rprsAddr1"
              id="rprsAddr1"
              :value.sync="data.rprsAddr1"
              placeholder="MCOP-01-01-05-07"
              :maxlength="66"
              :err-msg-param="{filed:$t('MCOP-01-01-05-07'), max:66}"
              :required="`${$config.SITECODE_OGCBD}|${$config.SITECODE_OGHCM}|${$config.SITECODE_OGMMR}`"
              toLowerCase
            />
          </div>
          <div class="input-text-field">
            <input-text
              ref="rprsAddr2"
              id="rprsAddr2"
              :value.sync="data.rprsAddr2"
              :maxlength="66"
              :err-msg-param="{filed:$t('MCOP-01-01-05-07'), max:66}"
              toLowerCase
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 도시, 국가 -->
    <div class="form-row">
      <input-text
        ref="rprsAddr3"
        id="rprsAddr3"
        :value.sync="data.rprsAddr3"
        label-i18n="MCOP-01-01-05-08"
        placeholder="MCOP-01-01-05-08"
        toLowerCase
      />
    </div>
  </div>
</template>
<script>
import Required from "@/components/template/Required";
import { mapFields } from "vuex-map-fields";

export default {
  props: ["data"],
  components: {
    Required,
  },
  computed: {
    ...mapFields(["siteCode"]),
  },
  methods: {
    touch() {
      this.$refs.rprsNmad.$v.$touch();
      this.$refs.rprsAddr1.$v.$touch();
      this.$refs.rprsAddr2.$v.$touch();
      this.$refs.rprsAddr3.$v.$touch();
    },
  },
};
</script>